module.exports = __webpack_public_path__ + "static/media/17_crisalide.45d81397.jpg";